import Urls from "./Urls";
import {AuthManager} from "@cuatroochenta/co-admin-react-library";
import {ResponseCSV} from "../modules/UpdateExpirationCardsContainer";

export default class TaskUpdateExpirationCards {

    private getPostInfo(file: File) {

        const formData = new FormData();
        formData.append("file", file);

        return {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + AuthManager.getAuthToken()
            },
            body: formData
        }
    }

    public get(file: File): Promise<ResponseCSV> {
        return fetch(Urls.URL_UPDATE_EXPIRATION_CARDS, this.getPostInfo(file))
            .then(async (res) => {
                const json = await res.json();

                if (!res.ok) {
                    return Promise.reject({
                        success: false,
                        message: null,
                        error: json?.error ?? json?.message ?? `${res.status} ${res.statusText}`,
                    } as ResponseCSV);
                }

                const msg =
                    json.message ??
                    `Número de usuarios modificados: ${json.numUsersModified}.\n` +
                    `Emails:\n- ${(json.usersModifiedEmail || []).join('\n- ')}`;

                return {
                    success: true,
                    message: msg,
                    error: null,
                } as ResponseCSV;
            });
    }
}